import Vue from 'vue'
import Vuex from 'vuex'
import personal from './modules/personal'
import experiment from './modules/experiment'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    score: 0,
    indexTimer: null,
    languagePath: '',
    scoreModule: [
      { id: 20, score: 0 },
      { id: 21, score: 0 },
      { id: 22, score: 0 },
      { id: 23, score: 0 },
      { id: 24, score: 0 },
      { id: 25, score: 0 },
      { id: 30, score: 0 },
      { id: 31, score: 0 },
    ],
    userLogin: false,
    userInfo: undefined,
    language: '中',
    language_value: 'zh',
    languages: [
      { value: 'zh', label: '简体中文', symbol: '中' },
      { value: 'zh-hk', label: '繁體中文', symbol: '繁' },
      { value: 'th-TH', label: 'ภาษาไทย', symbol: 'TH' },
      { value: 'en', label: 'English', symbol: 'EN' },
      { value: 'ms-MY', label: 'Malaysia', symbol: 'MY' },
      { value: 'vi-VN', label: 'Việt nam', symbol: 'VN' },
    ],
    crumbs: undefined,
    menus: []
  },
  mutations: {
    SET_SCORE(state, val) {
      state.score = val
    },
    SET_LANGUAGEPATH(state, val) {
      state.languagePath = val
    },
    SETUSERLOGIN(state, val) {
      state.userLogin = val
    },
    SET_USETINFO(state, val) {
      state.userInfo = val
    },
    SET_LANGUAGE(state, val) {
      state.language = val
    },
    SET_CRUMBS(state, val) {
      state.crumbs = val
    },
    SET_MENUS(state, val) {
      state.menus = val
    },

    SET_SCORE_MODULE(state, val) {
      state.scoreModule.forEach(v => {
        if (v.id === val.id) {
          v.score = val.score
        }
      })

      // let scored = 0
      // state.scoreModule.forEach(v => {
      //   scored += v.score
      // })
      // state.score = scored
    },
    SET_LANGUAGE_VALUE(state, val) {
      state.language_value = val
    },
  },
  actions: {
  },
  modules: {
    personal,
    experiment
  }
})
